import { render, staticRenderFns } from "./testWorkflow.vue?vue&type=template&id=cb9845ee"
import script from "./testWorkflow.vue?vue&type=script&lang=js"
export * from "./testWorkflow.vue?vue&type=script&lang=js"
import style0 from "./testWorkflow.vue?vue&type=style&index=0&id=cb9845ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports